import type * as React from "react";

import { cn } from "../lib/cn";

export interface FieldErrorProps extends Omit<
  React.HTMLAttributes<HTMLParagraphElement>,
  "aria-live"
> {
  /** Renders nothing when empty, so `{error && ...}` guards are unnecessary. */
  children?: React.ReactNode;
  ref?: React.Ref<HTMLParagraphElement>;
}

/**
 * One control's write failure, with a non-droppable `aria-live="polite"`.
 * Point a form field's `aria-describedby` at its `id` too. Whole-panel fetch
 * failures are `PanelError`; unhandled writes fall to the app's `WriteErrorNotice`.
 */
export function FieldError({ children, className, ...rest }: FieldErrorProps) {
  if (children == null || children === false || children === "") return null;

  return (
    <p
      {...rest}
      aria-live="polite"
      className={cn("text-sm text-ink-stopped", className)}
    >
      {children}
    </p>
  );
}
